import React from 'react'
import { useDispatch } from '@/hooks/dispatch'
import { actionCreators } from '@/store/ReportSubmissions'
import { TableStatusIndicator } from '@/components/reporting/tableStatusIndicator'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'
import { useTableContext } from '@/components/report-tables/editable/editableTableContext'
import { useSelector } from 'react-redux'
import { useBackgroundJobTracking } from '@/hooks/useBackgroundJobRunning'

const TableTools = React.memo(function TableTools ({ showPrefillFromPrevious, readonly }) {
  const { runCheckingRules,
    hasCheckingRules,
    clearReportData
  } = useTableContext()
  const [prefillFromPrevious] = useDispatch([actionCreators.prefillFromPrevious])
  const { hasPreviousGroup } = useSelector(state => {
    return {
      hasPreviousGroup: state.reportSubmissions.reportSubmission && state.reportSubmissions.reportSubmission.hasPreviousGroup,
      reportSubmissionGroupId: state.reportSubmissions.reportSubmission && state.reportSubmissions.reportSubmission.reportInstanceGroupId
    }
  })

  const { running: checkingRulesRunning, start: onRunCheckingRules } = useBackgroundJobTracking(runCheckingRules)

  return <React.Fragment>
    <div>
      <div className='btn-group-right r-s-d-btns'>
        <TableStatusIndicator />
        {hasCheckingRules && <Button
          disabled={readonly || checkingRulesRunning}
          color='primary'
          className='btn btn-md'
          onClick={onRunCheckingRules}>
          <Resx name='Reporting.RunCheckingRules' />
        </Button>}
        {showPrefillFromPrevious && <Button
          color='primary'
          disabled={readonly || !hasPreviousGroup || checkingRulesRunning}
          className='btn btn-md'
          onClick={prefillFromPrevious}>
          <Resx name='Reporting.PrefillFromPrevious' />
        </Button>}
        <Button
          color='primary'
          disabled={readonly || checkingRulesRunning}
          className='btn btn-md btn-danger'
          onClick={clearReportData}
          confirmText='Reporting.ClearConfirmation'
          confirmTitle='Reporting.ClearData'>
          <Resx name='Reporting.ClearData' />
        </Button>
      </div>
    </div>
  </React.Fragment>
})

export { TableTools }



// WEBPACK FOOTER //
// ./src/components/reporting/tableTools.js